import React, { useState, useEffect } from "react";
import { getDoctorDetails, getDoctorDirectorList } from "../../api/api";
import { Speciality } from "../../api/api";
import { getAllCenter } from "../../api/api";
// import 'react-multi-select-component/dist/lib.css';
import "./DoctorsGridPageCss/DoctorDirectorySection.css";
import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import FadeLoader from "react-spinners/FadeLoader";
import DoctorDetailsPage from "./DoctorDetailsPage";
import CustomLoader from "../../common/loader/CustomLoader";
// import { MultiSelect } from "react-multi-select-component";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Chip,
  Box,
  Button,
  TextField,
} from "@mui/material";
import { useDoctor } from "../../Contexts/Doctor.contexts";
import { useNavigate } from "react-router-dom";
import backbutton from "../../Assets/back-button.png";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, InputAdornment } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function DoctorDirectory() {
  const [info, setInfo] = useState([]); // save doctor list
  const [doctorName, setDoctorName] = useState("");
  const [request, setRequest] = useState({
    doctorName: "",
    center_id: [],
    specialization_id: [],
  });

  const [center_id, setCenter_id] = useState("");
  const [allcenter, setAllcenter] = useState([]); // save center list
  const [allspeciality, setAllspeciality] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [doctorData, setDoctorData] = useState({});
  const [loadingDoctorList, setLoadingDoctorList] = useState(false);
  const { doctorListData } = useDoctor();
  const navigate = useNavigate();

  console.log("doctorListData", doctorListData);

  // call doctor speciality api

  useEffect(() => {
    fetchAllSpeciality();
  }, []);

  const fetchAllSpeciality = async () => {
    try {
      setLoading(true);
      const res = await Speciality();
      if (res?.data?.status === "Succesful") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setAllspeciality(apiData);
          setMessage("");
        } else {
          setAllspeciality([]);
          setMessage("No data found");
        }
      } else {
        setMessage("Problem on API");
        setAllspeciality([]);
      }
    } catch (error) {
      console.error("Error fetching Speciality:", error);
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // complete speciality api
  console.log("allspeciality====>", allspeciality);

  //  call doctor centre api

  useEffect(() => {
    fetchAllCenter();
  }, []);

  const fetchAllCenter = async () => {
    const payload = {};
    try {
      setLoading(true);
      const res = await getAllCenter(payload);
      if (res?.data?.status === "Succesful") {
        const apiData = res?.data?.data || [];

        if (apiData.length > 0) {
          //fetch data in setAllCenter
          setAllcenter(apiData);
          setMessage(""); // clear message when data found
        } else {
          // set empty array when data not found
          setAllcenter([]);
          setMessage("No data found"); // set message when data not found
        }
      } else {
        setAllcenter([]);
        setMessage("Problem on API");
      }

      console.log("res.data===>", res?.data);
    } catch (error) {
      console.error("Error fetching  faq data :", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("allcenter====>", allcenter);

  // complete call doctor centre api

  // call getDoctorDirectorList api

  useEffect(() => {
    console.log("request====>", request);

    fetchDoctorDirectorList();
  }, [request]);

  const fetchDoctorDirectorList = async () => {
    try {
      setLoadingDoctorList(true);
      const payload = {
        ...request,
        center_id: request.center_id.join(","),
        specialization_id: request.specialization_id.join(","),
      };
      console.log("payloadhey=====>", payload);

      const res = await getDoctorDirectorList(payload);
      if (res?.data?.status === "Success") {
        const apiData = res?.data?.data || [];

        if (apiData.length > 0) {
          //fetch data in getDoctorDirectoryList
          setInfo(apiData);
          setMessage(""); // clear message when data found
        } else {
          // set empty array when data not found
          setInfo([]);
          setMessage("No data found"); // set message when data not found
        }
      } else {
        setInfo([]);
        setMessage("Problem on API");
      }

      console.log("res.data===>", res?.data);
    } catch (error) {
      //   console.error("Error fetching  faq data :", error);
      console.log("error");
    } finally {
      setLoadingDoctorList(false);
    }
  };

  const valupd = (e) => {
    setRequest({ ...request, [e.target.name]: e.target.value });
  };
  console.log("request==>", request);
  console.log("info====>", info);

  const handleReset = () => {
    setRequest({
      doctorName: "",
      center_id: [],
      specialization_id: [],
    });
  };
  // function for merged object from api call//

  const mergeDoctorObject = (doctors) => {
    if (!doctors || doctors.length === 0) return {};

    const first = doctors[0];

    const merged = {
      doctor_id: first.doctor_id,
      doctor_name: first.doctor_name,
      DoctorPictureUrl: first.DocPicture,
      specialization: first.specialization,
      experience: first.experience,
      avgRating: first.avgRating,
      AboutDoctor: first.AboutDoctor,
      Training: first.Training,
      Awards: first.Awards,
      Designation: first.Designation,
      Membership: first.Membership,
      centers: [],
    };

    doctors.forEach((doc) => {
      if (!merged.centers.some((c) => c.center_id === doc.center_id)) {
        merged.centers.push({
          center_id: doc.center_id,
          center_name: doc.center_name,
          Fees: doc.Fees,
          availableDays: doc.availableDays,
        });
      }
    });

    return merged;
  };

  // const handleDrSelect = async (doctorId) => {
  //   const payload = { doctor_id: doctorId };

  //   try {
  //     setLoading(true);
  //     const response = getDoctorDetails(payload);

  //     response
  //       .then((res) => {
  //         const doctorData = res?.data?.data || [];
  //         const doctorObj = mergeDoctorObject(doctorData);

  //         if (doctorObj && doctorObj.doctor_id) {
  //           console.log("Merged Doctor Object:", doctorObj);
  //           setDoctorData(doctorObj);
  //           setShowModal(true);
  //         } else {
  //           console.log("No valid doctor data received");
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("Error in Doctor Details API:", err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   } catch (error) {
  //     console.log("Error fetching doctor details", error);
  //   }
  // };

  const handleDrSelect = (doctorId) => {
    const matchedDoctor = doctorListData.find(
      (doc) => String(doc.doctor_id) === String(doctorId)
    );

    if (matchedDoctor) {
      // console.log("Matched Doctor:", matchedDoctor);
      // setDoctorData(matchedDoctor);
      // setShowModal(true);
      navigate(`/doctor/${matchedDoctor.doctor_id}`, {
        state: { doctor: matchedDoctor },
      });
    } else {
      console.log("No doctor found with id:", doctorId);
    }
  };

  // const handleDrSelect = (doctor) => {
  //   navigate(`/doctor/${doctor.doctor_id}`, {
  //     state: { doctor },
  //   });
  // };

  const backButtonFunction = () => {
    navigate("/doctors-grid");
  };

  return (
    <>
      <div className="directory">
        <h1 className="heading">Doctor Directory </h1>
        <p className="text">
          Note: Doctor sehedules are subject to change without prior notice
        </p>
      </div>
      {/* <div className="back-button-direcotory" onClick={backButtonFunction}>
        <img src={backbutton} alt="Back" style={{ color: "grey" }} />
      </div> */}
      <div className="main-container">
        <div className="outer-border">
          <div className="inner-border">
            <div className="second-main-container">
              {/* input field */}
              {/* name  */}
              <div className="input_field">
                {/* Doctor's Name :
  <input
    type="text"
    name="doctorName"
    onChange={valupd}
    value={request.doctorName}   // ✅ controlled input
  /> */}
                {/*  */}
                <FormControl
                  sx={{
                    width: 310,
                    height: 48,
                    mr: 2,

                    "& .MuiOutlinedInput-input": {
                      padding: "14px 14px",
                    },
                  }}
                >
                  <TextField
                    label="Doctor's Name"
                    name="doctorName"
                    value={request.doctorName}
                    onChange={valupd}
                    placeholder="Search Doctor"
                    variant="outlined"
                    // size="small"
                    InputProps={
                      {
                        // endAdornment: request.doctorName && (
                        //   <span
                        //     onClick={() =>
                        //       valupd({
                        //         target: { name: "doctorName", value: "" },
                        //       })
                        //     }
                        //     style={{
                        //       cursor: "pointer",
                        //       fontSize: "20px",
                        //       paddingRight: "6px",
                        //       color: "#555",
                        //     }}
                        //   >
                        //     ✕
                        //   </span>
                        // ),
                      }
                    }
                  />
                </FormControl>

                {/* name complete  */}

                {/* input field select dropdown */}
                <FormControl
                  sx={{
                    width: 310, // fixed width
                    height: 48, // fixed height for the box
                    mr: 2,
                    "& .MuiInputBase-root": {
                      height: 48, // input field height
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 14px", // vertical alignment
                    },
                  }}
                >
                  <InputLabel id="center-label">Preferred Location</InputLabel>
                  <Select
                    labelId="center-label"
                    multiple
                    value={request.center_id}
                    onChange={(e) =>
                      setRequest({ ...request, center_id: e.target.value })
                    }
                    input={<OutlinedInput label="Preferred Location" />}
                    renderValue={
                      (selected) =>
                        selected
                          .map(
                            (id) =>
                              allcenter.find((c) => c.center_id === id)
                                ?.center_name
                          )
                          .filter(Boolean)
                          .join(", ") // 👈 join by comma
                    }
                    MenuProps={MenuProps}
                  >
                    {allcenter.map((center) => (
                      <MenuItem key={center.center_id} value={center.center_id}>
                        <Checkbox
                          checked={request.center_id.includes(center.center_id)}
                        />
                        <ListItemText primary={center.center_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Speciality */}
                <FormControl
                  sx={{
                    width: 330, // fixed width
                    height: 48, // fixed height for the box
                    mr: 2,
                    "& .MuiInputBase-root": {
                      height: 48, // input field height
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 14px", // vertical alignment
                    },
                  }}
                >
                  <InputLabel id="speciality-label">Speciality</InputLabel>
                  {/* Speciality: */}
                  <Select
                    labelId="speciality-label"
                    multiple
                    value={request.specialization_id}
                    onChange={(e) =>
                      setRequest({
                        ...request,
                        specialization_id: e.target.value,
                      })
                    }
                    input={<OutlinedInput label="Speciality" />}
                    renderValue={(selected) =>
                      selected
                        .map(
                          (id) =>
                            allspeciality.find(
                              (s) => s.specialization_id === id
                            )?.specialization
                        )
                        .filter(Boolean)
                        .join(", ")
                    }
                    MenuProps={MenuProps}
                  >
                    {allspeciality.map((spec) => (
                      <MenuItem
                        key={spec.specialization_id}
                        value={spec.specialization_id}
                      >
                        <Checkbox
                          checked={request.specialization_id.includes(
                            spec.specialization_id
                          )}
                        />
                        <ListItemText primary={spec.specialization} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <div className="filter-item">
                  <div className="btn-back">
                    <button
                      type="button"
                      className="reset-btn"
                      onClick={handleReset}
                    >
                      Reset
                    </button>

                    <button
                      type="button"
                      className="back-btn"
                      onClick={backButtonFunction}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>

              {/* complete input field */}

              {/* set loader  */}

              {loadingDoctorList && (
                <div
                  className="loader-style"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "20px 0",
                  }}
                >
                  <CustomLoader />
                </div>
              )}

              {/* Doctor data */}

              {/* {!loadingDoctorList && info.length === 0 && <p>No doctors found.</p>} */}
              {/* {!loadingDoctorList && info.length > 0 && ( */}

              {/* start show the multi selected portion  */}
              {/* Selected Filters Display */}

              <div className="selected-filters">
                {request.center_id.length > 0 && (
                  <div className="filter-group">
                    <strong>Location : </strong>
                    {request.center_id.map((id) => {
                      const center = allcenter.find((c) => c.center_id === id);
                      return (
                        <span key={id} className="filter-chip">
                          {center ? center.center_name : id}
                          <button
                            type="button"
                            onClick={() =>
                              setRequest((prev) => ({
                                ...prev,
                                center_id: prev.center_id.filter(
                                  (x) => x !== id
                                ),
                              }))
                            }
                          >
                            ×
                          </button>
                        </span>
                      );
                    })}
                  </div>
                )}

                {request.specialization_id.length > 0 && (
                  <div className="filter-group">
                    <strong>Specialities : </strong>
                    {request.specialization_id.map((id) => {
                      const spec = allspeciality.find(
                        (s) => s.specialization_id === id
                      );
                      return (
                        <span key={id} className="filter-chip">
                          {spec ? spec.specialization : id}
                          <button
                            type="button"
                            onClick={() =>
                              setRequest((prev) => ({
                                ...prev,
                                specialization_id:
                                  prev.specialization_id.filter(
                                    (x) => x !== id
                                  ),
                              }))
                            }
                          >
                            ×
                          </button>
                        </span>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* end show the multi selected portion  */}

              <div>
                {info.map((v, i) => (
                  <div key={i} className="specialization-block">
                    <h2 className="specialization-title">
                      {v.specialization_name}
                    </h2>

                    <table className="doctor-table">
                      <colgroup>
                        <col style={{ width: "14%" }} />
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "12%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                        <col style={{ width: "8%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th rowspan="2"> Name</th>
                          <th rowspan="2">Degree</th>
                          <th rowspan="2">Center</th>
                          <th colSpan="7">
                            Please Double-click on schedule below to proceed
                            with OPD Booking
                          </th>
                        </tr>
                        <tr className="days-row">
                          <th>Mon</th>
                          <th>Tue</th>
                          <th>Wed</th>
                          <th>Thu</th>
                          <th>Fri</th>
                          <th>Sat</th>
                          <th>Sun</th>
                        </tr>
                      </thead>
                      <tbody>
                        {v.doctor.map((w, j) => (
                          <tr
                            style={{ cursor: "pointer" }}
                            key={j}
                            onClick={() => handleDrSelect(w.doctor_id)}
                          >
                            <td
                              className="ellipsis"
                              title={`Dr. ${w.doctor_name}`.trim()}
                            >
                              Dr. {w.doctor_name.trim()}
                            </td>
                            <td className="ellipsis" title={w.degree.trim()}>
                              {w.degree.trim()}
                            </td>
                            <td
                              className="ellipsis"
                              title={w.center_name.trim()}
                            >
                              {w.center_name.trim()}
                            </td>

                            {[
                              "monday",
                              "tuesday",
                              "wednesday",
                              "thursday",
                              "friday",
                              "saturday",
                              "sunday",
                            ].map((day, k) => {
                              const slot = w.schedule.find(
                                (s) => s.day.toLowerCase() === day
                              );
                              const text = slot ? slot.time.trim() : "-";
                              return (
                                <td
                                  className="ellipsis day-cell"
                                  key={k}
                                  title={text}
                                >
                                  {text}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
              {/* )}  */}

              {/* complete doctor data */}
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <DoctorDetailsPage
          doctor={doctorData}
          onClose={() => setShowModal(false)}
        />
      )}

      {/* <ServiceSection />
      <ConsultSection /> */}
    </>
  );
}
